export const Config = {
  apiUrl: window.location.origin,
    //reCAPTCHASiteKey: "6Le21e8qAAAAAJ2LvIGZEkL4qOfyS1BiFcwg3Hjs", //local
    reCAPTCHASiteKey: "6Lc9BPAqAAAAAMZkUmPrMhRu7U9YWlQvLTV6meMj", //dev
};
